import { isPrivateRoute } from '@/donor/routes';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAnalytics } from '@/lib/use-analytics';

export const PublicAnalytics = (): null => {
  const location = useLocation();
  const track = useAnalytics();
  const lastNavigation = useRef<string | null>(null);
  useEffect(() => {
    if (isPrivateRoute(location.pathname)) return;
    const navigation = `${location.key}:${location.pathname}:${location.search}`;
    if (lastNavigation.current === navigation) return;
    lastNavigation.current = navigation;
    track('Public Page Viewed');
  }, [location.key, location.pathname, location.search, track]);
  return null;
};
